import mixin from 'privates/utils/mixin';
import Background from 'ui/Background';
import ContainableMixin from './mixins/ContainableMixin';
import * as members from 'privates/privateMembers';

/**
 * @class State
 * @summary A `State` from a `MultiStateBox` that can contain other elements.
 * @mixes $w.Element
 * @mixes $w.Background
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.StateBoxState
 * @definitionId wysiwyg.viewer.components.StateBoxState
 * @definitionId wysiwyg.viewer.components.StateStripState
 */
class State extends Background {
    /**
     * @member name
     * @label property
     * @syntax
     * get name(): string
     * @summary Gets the name of the state.
     * @description
     *  A state's `name` is used as a label for the state.
     *
     *  A state's `name` is set in the Editor using the <a href="https://support.wix.com/en/article/manage-states" target="_blank">Manage States panel</a>.
     *  ![Manage States](images/manage_states.png "Manage States")
     * @snippet [State-name.es6=Get a state's name]
     * @type {external:String}
     * @memberof $w.State
     * @readonly
     * @instance
     */
    get name() {
        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        return RMI.getData(compId).title;
    }

    get _id() {
        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        return RMI.getData(compId).name;
    }

    toJSON() {
        const {id, _id, type, global, background, rendered, name} = this;
        return {id, _id, type, global, background: background.src, rendered, name};
    }
}

mixin(State.prototype, ContainableMixin.prototype);

export default State;



// WEBPACK FOOTER //
// ./js/modules/ui/State.es6